import { OnlineStorage } from "@tblabs/storage";
import { Div, PopupMenu, RefBool } from "@tblabs/truffle";
import { Router } from "../Services/Router";
import { IStorageUser } from "@tblabs/storage/IStorageUser";
import { AuthIcon } from "./AuthIcon";
import { UserSectionWhenLoggedIn } from "./UserSectionWhenLoggedIn";


export class UserSection extends Div
{
    constructor(_storage: OnlineStorage, _router: Router)
    {
        super();

        const isUserAuthorized = new RefBool(false);

        _storage.OnUserChange((u: IStorageUser, isAuthorized: boolean) =>
        {
            isUserAuthorized.value = isAuthorized;
        });

        this.Append(
            new AuthIcon()
                .OnClick(() => _router.GoToLoginPage())
                .VisibleWhen(isUserAuthorized, v => v == false),
            new PopupMenu({
                "🏠 Panel administracyjny": () => _router.GoToMainPage(),
                "🔒 Wyloguj": () => _storage.Logout(),
            },
                new UserSectionWhenLoggedIn(_storage, _router)
                    .VisibleWhen(isUserAuthorized, v => v == true, "flex")
            ),
        );
    }
}
